import React, { useEffect, useState } from 'react';
import { IncidencePendingBanner } from 'components/dashboard/IncidencePendingBanner';
import { Header } from 'components/header/Header';
import MainSider from '../sider/MainSider/MainSider';
import MainContent from '../MainContent/MainContent';
import { MainHeader } from '../MainHeader/MainHeader';
import { Outlet, useLocation } from 'react-router';
import { useResponsive } from 'hooks/useResponsive';
import { usersPaths } from 'constants/routePaths';
import { Layout } from 'antd';
import 'styles/sass/layout.scss';

const MainLayout: React.FC = () => {
  const [isTwoColumnsLayout, setIsTwoColumnsLayout] = useState(true);
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const { isDesktop } = useResponsive();
  const location = useLocation();

  useEffect(() => {
    setIsTwoColumnsLayout(
      [usersPaths.basePath].includes(location.pathname) && isDesktop
    );
  }, [location.pathname, isDesktop]);

  return (
    <Layout>
      <MainSider
        isCollapsed={siderCollapsed}
        setCollapsed={setSiderCollapsed}
      />
      <Layout className="layout-main">
        <MainHeader
          isTwoColumnsLayout={isTwoColumnsLayout}
          onToggleSider={() => setSiderCollapsed(!siderCollapsed)}
        >
          <Header />
        </MainHeader>
        <MainContent id="main-content" $isTwoColumnsLayout={isTwoColumnsLayout}>
          <div className="layout-main-body">
            <IncidencePendingBanner audience="supervisor" />
            <Outlet />
          </div>
        </MainContent>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
